import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { client, urlFor } from '../SanityClient';
import ProjectsPageLayout from '../ProjectsPageLayout';

const QUERY_BY_SLUG =  `
*[
  _type == "project" &&
  (
    coalesce(projectSlug.current, projectSlug) == $slug ||
    lower(coalesce(projectSlug.current, projectSlug)) == lower($slug)
  )
][0]{
  title,
  description,
  location,
  client,
  market,
  services[]->{
    _id,
    header,
    serviceSlug
  },
  cost,
  mainImage,
  gallery[]{
    asset->{ _id, url },
    alt,
    caption
  }
}
`;

const QUERY_BY_ID = /* groq */ `
*[_type == "project" && _id == $id][0]{
  title,
  description,
  location,
  client,
  market,
  services[]->{
    _id,
    header,
    serviceSlug
  },
  cost,
  mainImage,
  gallery[]{
    asset->{ _id, url },
    alt,
    caption
  }
}
`;

export default function ProjectsPage() {
  const { projectSlug, projectId } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const query = projectSlug ? QUERY_BY_SLUG : QUERY_BY_ID;
        const params = projectSlug ? { slug: projectSlug } : { id: projectId };
        const doc = await client.fetch(query, params);
        if (!cancelled) setProject(doc || null);
      } catch (e) {
        console.error('ProjectsPage fetch error:', e);
        if (!cancelled) setProject(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [projectSlug, projectId]);

  if (loading) return <p style={{ padding: '2rem' }}>Loading…</p>;
  if (!project) return <Navigate to="/our-work" replace />;

  const imageSrc = project.mainImage
    ? urlFor(project.mainImage).width(1600).auto('format').url()
    : null;

  const gallery = (project.gallery || []).map((img, i) => ({
    src: img?.asset?.url || (img ? urlFor(img).width(1200).auto('format').url() : ''),
    alt: img?.alt || `${project.title} image ${i + 1}`,
    caption: img?.caption || ''
  }));

  const services = Array.isArray(project.services)
    ? project.services.map(s => s?.header || s?.serviceSlug).filter(Boolean)
    : [];

  return (
    <ProjectsPageLayout
      title={project.title}
      description={project.description}
      location={project.location}
      client={project.client}
      market={project.market}
      services={services}
      cost={project.cost}
      imageSrc={imageSrc}
      gallery={gallery}
    />
  );
}
